import type { CvSectionId, CvSectionsConfig } from "@tabbio/types";
import { getVisibleCvSections as resolveVisibleCvSections } from "@tabbio/utils/cv-section-config";
import type { CVProfile } from "./cv-mock-data";
export type { CvSectionsConfig };
export {
  DEFAULT_CV_SECTION_ORDER,
  ensureCvSectionVisible,
  getHiddenCvSections,
  getVisibleCvSections,
  insertCvSectionInDefaultPosition,
  isCvSectionVisible,
  moveCvSection,
  normalizeCvSectionOrder,
  normalizeCvSectionsConfig,
  setCvSectionVisibility,
} from "@tabbio/utils/cv-section-config";

export function getCvSectionItemCount(
  profile: CVProfile,
  sectionId: CvSectionId,
): number {
  switch (sectionId) {
    case "summary":
      return profile.summary.trim().length > 0 ? 1 : 0;
    case "careerHighlights":
      return profile.highlights.length;
    case "skills":
      return profile.skillGroups.length;
    case "experience":
      return profile.experience.length;
    case "education":
      return profile.education.length;
    case "projects":
      return profile.projects?.length ?? 0;
    case "certifications":
      return profile.certifications.length;
    case "languages":
      return profile.languages.length;
  }
}

/**
 * A CV can have a valid identity/header while its actual document body is
 * still blank. Keep that distinction in one place so native and web previews
 * show the same first-run guidance without mistaking contact details for CV
 * content.
 */
export function hasCvBodyContent(
  profile: CVProfile,
  sectionsConfig?: CvSectionsConfig | null,
): boolean {
  return resolveVisibleCvSections(sectionsConfig).some(
    (sectionId) => getCvSectionItemCount(profile, sectionId) > 0,
  );
}
